import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const IsLoggedIn = ({ children, withNavigate = false }) => {
  const isAuthenticated = useSelector((state) => state.auth.authenticated);
  const navigate = useNavigate();

  useEffect(() => {
    if (withNavigate && !isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);

  return isAuthenticated ? children : null;
};

export default IsLoggedIn;
